import angular from 'angular';
import '../../shared.module';
import template from './password-generator.component.html';
import './password-generator.component.scss';
import { generateStrongPassword } from '../../helpers/password-generator.helper';

class PasswordGeneratorController {
  constructor($window, NotificationService) {
    this.$window = $window;
    this.NotificationService = NotificationService;
    this.generated = '';
  }

  get supported() {
    return Boolean(this.$window.crypto && this.$window.crypto.getRandomValues);
  }

  generate() {
    if (!this.supported) return;
    this.generated = generateStrongPassword(this.$window.crypto);
    if (this.onGenerate) this.onGenerate({ password: this.generated });
  }

  copy() {
    const clipboard = this.$window.navigator && this.$window.navigator.clipboard;
    if (!clipboard || !this.generated) return;
    clipboard
      .writeText(this.generated)
      .then(() => this.NotificationService.success('Senha copiada.'));
  }
}

PasswordGeneratorController.$inject = ['$window', 'NotificationService'];

angular.module('app.shared').component('cpPasswordGenerator', {
  bindings: {
    onGenerate: '&'
  },
  controller: PasswordGeneratorController,
  controllerAs: 'vm',
  template
});
